import { render, staticRenderFns } from "./VasionInput.vue?vue&type=template&id=2a98f6ee&scoped=true&"
import script from "./VasionInput.vue?vue&type=script&lang=js&"
export * from "./VasionInput.vue?vue&type=script&lang=js&"
import style0 from "./VasionInput.vue?vue&type=style&index=0&id=2a98f6ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98f6ee",
  null
  
)

export default component.exports